/**
 * Auto-generated asset manifest for cache busting
 * Generated at build time based on file content hashes
 * DO NOT EDIT - This file is automatically generated
 */

const assetManifest = {
  "/favicons/favicon-16x16.png": "d664b750",
  "/favicons/favicon.ico": "bc1f4163",
  "/favicons/fort/favicon-16x16.png": "ea58db92",
  "/favicons/fort/favicon.ico": "d022f1f2",
  "/favicons/fort/favicon 2.ico": "d022f1f2",
  "/favicons/fort/favicon-32x32.png": "1d96c5db",
  "/favicons/fort/apple-touch-icon.png": "827b9592",
  "/favicons/favicon-32x32.png": "dd2d748f",
  "/favicons/apple-touch-icon.png": "14decfe1",
  "/images/modals/TemplateInfoModal-BrandStyleGuide.png": "7a5737c2",
  "/images/modals/TemplateInfoModal-AssetLibrary.png": "13b0a148",
  "/images/modals/TemplateInfoModal-UILibrary.png": "485d05eb",
  "/images/modals/portal-migration-modal/NewAdminDashboard.png": "a85d750e",
  "/images/modals/portal-migration-modal/PortalSharing.png": "a37c42c7",
  "/images/web-access/pattern@2x.png": "b8118d31",
  "/images/social/og-share.jpg": "8a893c2d",
  "/images/marketing/Features/unlimitedKits_16_9.png": "ed8a4af7",
  "/images/marketing/Features/integrations_16_9.png": "2827798f",
  "/images/marketing/Features/customBranding_16_9.png": "478aa820",
  "/images/marketing/Features/downloadRequests_16_9.png": "ad7780d8",
  "/images/marketing/Features/insights_16_9.png": "06a6d5cf",
  "/images/marketing/Features/customFields_16_9.png": "60230346",
  "/images/marketing/Features/tags_16_9.png": "02e553d0",
  "/images/marketing/Features/guidelines_16_9.png": "84a6db3b",
  "/images/marketing/Features/publicSharing_16_9.png": "e7347a49",
  "/images/marketing/Features/fileConversions_16_9.png": "5b5b8ac7",
  "/images/marketing/Features/enhancedSearch_16_9.png": "7a03d052",
  "/images/marketing/Features/customDomains_16_9.png": "fce725f7",
  "/images/marketing/Features/versionHistory_16_9.png": "66b217d6",
  "/images/marketing/Features/brandPortal_16_9.png": "ec85938d",
  "/images/marketing/Pricing/hero_3_2.png": "49700c37",
  "/images/marketing/Pricing/roi_3_2.png": "44738750",
  "/images/marketing/Affiliate/hero_3_2.png": "42a22bf6",
  "/images/marketing/Affiliate/content_3_2.png": "014675af",
  "/images/marketing/Enterprise/consistency_3_2.png": "296f56ea",
  "/images/marketing/Enterprise/support_3_2.png": "8bc79676",
  "/images/marketing/Enterprise/hero_3_2.png": "ae6df041",
  "/images/marketing/Enterprise/security_3_2.png": "feeb0588",
  "/images/marketing/CustomerLogos/bumble.svg": "69970f7a",
  "/images/marketing/CustomerLogos/texasam.svg": "f6a53749",
  "/images/marketing/CustomerLogos/matterport.svg": "f1178810",
  "/images/marketing/CustomerLogos/snap.svg": "41b7d62a",
  "/images/marketing/CustomerLogos/reddit.svg": "e1f363ac",
  "/images/marketing/CustomerLogos/lime.svg": "3ca83786",
  "/images/marketing/CustomerLogos/duolingo.svg": "c6bb21f4",
  "/images/marketing/CustomerLogos/intuit.svg": "394a8ec4",
  "/images/marketing/CustomerLogos/tntsports.svg": "b3100f18",
  "/images/marketing/CustomerLogos/denison.svg": "39231018",
  "/icons.svg": "3852388e",
} as const;

export default assetManifest;
